<template>
  <Menu v-slot="{ open }" as="div" class="relative shrink-0">
    <div ref="triggerRef">
      <MenuButton
        class="flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold whitespace-nowrap transition-colors bg-white border border-[#1c4848]/10 text-[#1c4848]/60 hover:bg-[#fafbfc] hover:text-[#1c4848]"
      >
        <span>Language: {{ selectedLabel }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" class="opacity-60"><path d="M7 10l5 5 5-5z"/></svg>
      </MenuButton>
    </div>
    <Teleport to="body">
      <transition enter-active-class="transition duration-150 ease-out" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
        <MenuItems
          v-if="open"
          class="fixed w-48 bg-white rounded-2xl shadow-xl border border-[#1c4848]/10 py-1.5 z-[1200] origin-top-right"
          :style="panelStyle"
        >
          <MenuItem v-for="opt in options" :key="opt.value" v-slot="{ active }">
            <button
              type="button"
              class="w-full text-left px-4 py-2.5 text-xs font-medium transition-colors"
              :class="opt.value === modelValue ? 'bg-[#1c4848]/10 text-[#1c4848]' : (active ? 'bg-[#fafbfc] text-[#1c4848]' : 'text-[#1c4848]/80')"
              @click="$emit('update:modelValue', opt.value)"
            >
              {{ opt.label }}
            </button>
          </MenuItem>
        </MenuItems>
      </transition>
    </Teleport>
  </Menu>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { useLanguagesStore } from '@/store/languages/index.js';
import { getLanguageLabel } from '@/utils/languageLabel.js';

const props = defineProps({
  modelValue: { type: String, default: '' },
});

defineEmits(['update:modelValue']);

const triggerRef = ref(null);
const panelStyle = ref({});

const languagesStore = useLanguagesStore();

onMounted(() => languagesStore.fetchLanguages());

function updatePosition() {
  if (!triggerRef.value) return;
  const rect = triggerRef.value.getBoundingClientRect();
  panelStyle.value = {
    top: `${rect.bottom + 8}px`,
    right: `${window.innerWidth - rect.right}px`,
  };
}

watch(triggerRef, (el) => { if (el) updatePosition(); }, { flush: 'post' });

const options = computed(() => {
  const list = languagesStore.languages ?? [];
  return [
    { value: '', label: 'All languages' },
    ...list.map((l) => ({ value: String(l.id), label: getLanguageLabel(l) })),
  ];
});

const selectedLabel = computed(() => options.value.find((o) => o.value === props.modelValue)?.label ?? 'All languages');
</script>
